export default __webpack_public_path__ + "static/media/EastTroyLightsGamePoster.28a9ec13.png";